(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/casino-store/assets/javascripts/hooks/use-favorites.js') >= 0) return;  svs.modules.push('/components/casino-react/casino-store/assets/javascripts/hooks/use-favorites.js');
"use strict";

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

const _React = React,
  useState = _React.useState,
  useEffect = _React.useEffect,
  useCallback = _React.useCallback;
const favoritesApi = svs.components.casino_react.casinoStore.endpoints.favoritesApi;
const _svs$components$casin = svs.components.casino_react.maxFavoritesDialog,
  showMaxFavoritesDialog = _svs$components$casin.showMaxFavoritesDialog,
  MAX_FAVORITES = _svs$components$casin.MAX_FAVORITES;
const useFavorites = () => {
  const _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    favorites = _useState2[0],
    setFavorites = _useState2[1];
  const _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isPending = _useState4[0],
    setIsPending = _useState4[1];
  const userLoggedIn = svs.core.userSession.hasRole(svs.core.userSession.roles.PLAYER);
  const _favoritesApi$useGetF = favoritesApi.useGetFavoritesQuery(undefined, {
      skip: !userLoggedIn
    }),
    _favoritesApi$useGetF2 = _favoritesApi$useGetF.data,
    fetchedFavorites = _favoritesApi$useGetF2 === void 0 ? [] : _favoritesApi$useGetF2;
  const _favoritesApi$useUpda = favoritesApi.useUpdateFavoritesMutation(),
    _favoritesApi$useUpda2 = _slicedToArray(_favoritesApi$useUpda, 1),
    updateFavorites = _favoritesApi$useUpda2[0];
  useEffect(() => {
    setFavorites(fetchedFavorites);
  }, [fetchedFavorites.length]);
  const isFavorite = useCallback(gameName => favorites.includes(gameName), [favorites]);
  const addFavorite = useCallback(async gameName => {
    if (favorites.length >= MAX_FAVORITES) {
      showMaxFavoritesDialog();
      return {
        success: false,
        error: 'Max favorites reached'
      };
    }
    setIsPending(true);
    const newFavorites = [gameName, ...favorites];
    setFavorites(newFavorites);
    const result = await updateFavorites(newFavorites);
    setIsPending(false);
    if (result.error) {
      setFavorites(favorites);
      return {
        success: false,
        error: result.error.message
      };
    }
    return {
      success: true
    };
  }, [favorites, updateFavorites]);
  const removeFavorite = useCallback(async gameName => {
    setIsPending(true);
    const newFavorites = favorites.filter(name => name !== gameName);
    setFavorites(newFavorites);
    const result = await updateFavorites(newFavorites);
    setIsPending(false);
    if (result.error) {
      setFavorites(favorites);
      return {
        success: false,
        error: result.error.message
      };
    }
    return {
      success: true
    };
  }, [favorites, updateFavorites]);
  const toggleFavorite = useCallback(async gameName => {
    if (isFavorite(gameName)) {
      return await removeFavorite(gameName);
    }
    return await addFavorite(gameName);
  }, [isFavorite, addFavorite, removeFavorite]);
  return {
    favorites,
    isPending,
    isFavorite,
    toggleFavorite,
    isLoggedIn: userLoggedIn
  };
};
setGlobal('svs.components.casino_react.casinoStore.hooks.useFavorites', useFavorites);

 })(window);